import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";
import farmHero from "@/assets/farm-hero-aerial-orchards.jpg";

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-24 md:pt-28">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src={farmHero}
          alt="Aerial view of California Central Valley farmland with almond orchards"
          className="w-full h-full object-cover"
          fetchPriority="high"
          width={1920}
          height={1080}
        />
        <div className="hero-overlay absolute inset-0"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center max-w-4xl mx-auto px-4 md:px-6">
        <p className="text-sm md:text-base text-primary tracking-[0.4em] uppercase mb-6 font-medium">
          California's Central Valley
        </p>
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl heading-luxury text-white mb-6 leading-tight">
          You Are Working With{" "}
          <span className="text-primary">Farm Experts</span>
        </h1>
        <p className="text-lg md:text-xl text-white/80 mb-10 max-w-2xl mx-auto leading-relaxed font-light">
          Specializing in agricultural real estate across Merced, Madera, and Fresno counties. 
          Almonds, pistachios, and premium farmland investments.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="tel:+15598719051">
            <Button size="lg" className="bg-primary text-foreground hover:bg-primary/90 px-8 py-6 text-lg font-semibold gap-2">
              <Phone className="h-5 w-5" />
              Call Us Today
            </Button>
          </a>
          <a href="#contact">
            <Button size="lg" className="bg-transparent border-2 border-white text-white hover:bg-primary hover:text-foreground hover:border-primary px-8 py-6 text-lg tracking-wider uppercase font-medium">
              Get In Touch
            </Button>
          </a>
        </div>
        
        <p className="text-white/50 text-sm mt-8 tracking-wider">
          We Would Like to Learn More About You
        </p>

        {/* Scroll Indicator */}
        <div className="flex justify-center mt-8">
          <div className="w-px h-16 bg-primary/50 relative">
            <div className="w-2 h-2 bg-primary rounded-full absolute -left-[3px] top-0 animate-bounce"></div>
          </div>
        </div>
      </div>

      {/* Extra bottom spacing */}
      <div className="pb-12"></div>
    </section>
  );
};

export default Hero;
